import { post } from '@partment/client'
import { errorToast } from '@repo/ui'
import { v3Path } from './versionedPath'

export const uploadKycDocument = async (payload: {
  document_type: string
  country_context: string
  document_file: File
}): Promise<void> => {
  const formData = new FormData()
  formData.append('document_type', payload.document_type)
  formData.append('country_context', payload.country_context)
  formData.append('document_file', payload.document_file)

  try {
    const response: any = await post(
      v3Path('profiles/me/kyc/documents/upload/'),
      formData,
      {
        headers: {
          'Content-Type': undefined,
        },
      },
    )

    // If API sends a structured success or error response:
    const data = response?.data || response

    if (data?.status === 'error') {
      const message = data?.message ?? 'Upload failed. Please try again.'

      throw new Error(message)
    }

    // successToast('Data saved successfully!')
  } catch (error: any) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Something went wrong. Please try again.'

    errorToast(message)
    throw error
  }
}
